<template>
  <Transition name="update-banner">
    <div
      v-if="visible"
      class="fixed bottom-24 lg:bottom-6 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 px-4 py-3 rounded-xl bg-surface border border-border shadow-xl max-w-[calc(100vw-2rem)]"
    >
      <i class="pi pi-sync text-indigo-400 shrink-0"></i>
      <span class="text-sm text-text">Hay una nueva versión disponible</span>
      <button
        @click="aplicarActualizacion"
        class="shrink-0 px-3 py-1.5 text-sm font-semibold rounded-lg bg-indigo-500/10 hover:bg-indigo-500/20 text-indigo-600 dark:text-indigo-400 border border-indigo-500/20 transition-colors"
      >
        Actualizar
      </button>
    </div>
  </Transition>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { updateDisponible, aplicarActualizacion } from '@/helpers/swUpdate';

const route = useRoute();

// En la landing pública no se molesta con el banner: el visitante recibe
// la versión nueva en su próxima visita de todos modos.
const visible = computed(() => updateDisponible.value && route.path !== '/');
</script>

<style scoped>
.update-banner-enter-active,
.update-banner-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.update-banner-enter-from,
.update-banner-leave-to {
  opacity: 0;
  transform: translate(-50%, 1rem);
}
</style>
